export default __webpack_public_path__ + "static/media/3435 spice rack A top.c7fac05c.png";